import Icons from '@shared/config/constants/Icons';
import languages from '@entities/language';
import React, { useEffect } from 'react';

import { changeLanguage } from '@entities/language/store';
import { ADDITIONAL_LANGUAGES } from '@entities/language';
import { useResponsive, useQuery } from '@shared/hooks';
import { setHtmlDirection } from '@shared/utils';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import styles from '../styles/NotFoundPage.module.css';

export const NotFoundPage: React.FC = () => {
  const [isMobile] = useResponsive('MOBILE');

  const { t, i18n } = useTranslation();
  const routeParams = useParams<{ lang?: string }>();

  const { query } = useQuery();
  const isWhite = query.get('isWhite') || false;

  const locale = routeParams?.lang || 'en';
  const supportedLanguage = [...languages, ...ADDITIONAL_LANGUAGES].find(
    (el) => el.lang === locale
  );

  useEffect(() => {
    if (!supportedLanguage) return;

    const language = {
      locale,
      displayName: supportedLanguage.name,
      direction: supportedLanguage.direction,
    };
    i18n.changeLanguage(locale);
    changeLanguage(language);
    setHtmlDirection(supportedLanguage.direction);
  }, [supportedLanguage, locale, i18n]);

  const darkBackgroundUrl = isMobile
    ? Icons.not_found_page_dark_background_mobile
    : Icons.not_found_page_dark_background;
  const whiteBackgroundUrl = isMobile
    ? Icons.not_found_page_white_background_mobile
    : Icons.not_found_page_white_background;

  const backgroundUrl = isWhite ? whiteBackgroundUrl : darkBackgroundUrl;

  return (
    <div
      className={styles.notFoundPageWrapper}
      style={{ backgroundImage: `url(${backgroundUrl})` }}
    >
      <div className={styles.notFoundTextContainer}>
        <p className={isWhite ? styles.text404NotFoundWhite : styles.text404NotFoundDark}>404</p>

        <p
          className={
            isWhite ? styles.description404NotFoundWhite : styles.description404NotFoundDark
          }
        >
          {t('page_not_found_text')}
        </p>
      </div>
    </div>
  );
};
